import { Resource } from "./Resource";
import { Assets } from "pixi.js";
import { ISkeletonData } from "../PixiSpineRuntime";
import { ISpineResource } from "@pixi-spine/loader-base";

export class SpineResource extends Resource
{
	get Name(): string { return this.name; }
	get Type(): string { return "spine"; }

	public skeletonData: ISkeletonData = null;

	public constructor(path: string, name: string = null, required: boolean = true) {
		super(path, name, required);
	}

	public Load(preventCache: boolean = false): void {
		if (preventCache) {
			Assets.cache.remove(this.path);
		}
		Assets.load<ISpineResource<ISkeletonData>>(this.path)
			.then(asset => {
				this.skeletonData = asset.spineData;
				this.Loaded();
			})
			.catch(() => {
				Assets.cache.remove(this.path);
				this.LoadError();
			});
	}

	public override Reload(preventCache: boolean = false): void {
		this.loaded = false;
		this.processed = false;
		this.skeletonData = null;
		this.Load(preventCache);
	}
}
